










import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'
import HeaderComponent from './../components/HeaderComponent.vue'
import FooterComponent from './../components/FooterComponent.vue'
import NavigationComponent from './../components/NavigationComponent.vue'
import SideNavigationComponent from './../components/SideNavigationComponent.vue'

@Component({
    // All component options are allowed in here
    name: 'main-layout',
    components: {
        'ldw-header': HeaderComponent,
        'ldw-footer': FooterComponent,
        'ldw-nav': NavigationComponent,
        'ldw-side-nav': SideNavigationComponent
    }
})

export default class MainLayout extends Vue {
    // private message: string = 'Hello!'
}
